export default {
    getCurrentMenuItem: (state) => {
        return state.currentMenuItem;
    },
}
